import React from 'react';
import './videoModal.css';

interface VideoModalProps {
  videoUrl: string | null;
  onClose: () => void;
}

/** 通用视频预览弹窗。播放地址为空时保持隐藏状态。 */
const VideoModal: React.FC<VideoModalProps> = ({ videoUrl, onClose }) => {
  return (
    <div className={`video-modal${videoUrl ? ' on' : ''}`}>
      <button type="button" className="vm-close" onClick={onClose} aria-label="关闭预览">
        ✕
      </button>
      <div className="vm-content">
        {videoUrl && (
          <video className="vm-player" src={videoUrl} controls autoPlay loop />
        )}
      </div>
    </div>
  );
};

export default VideoModal;
